import React, { useCallback } from 'react';
import c from 'classnames';

import { editableHotspotCursor } from './style';
import { HotspotContainerProps } from './types';

export const HOTSPOT_RADIUS = 16;

const HotspotContainer: React.FC<HotspotContainerProps> = (props) => {
  const {
    setHotspotsState,
    nodeElement,
    hotspotsState,
    setNewHotspotAdded,
    updateAttrs,
    setSelectedHotspot,
  } = props;

  const onDrop: React.DragEventHandler<HTMLDivElement> = useCallback(
    (event) => {
      const draggedIndex = event.dataTransfer.getData('draggedIndex');
      if (draggedIndex) {
        const draggedIndexInt = parseInt(draggedIndex, 10);
        const nodeBoudingClientRec = nodeElement?.getBoundingClientRect();
        const newHotspots = [...hotspotsState];
        newHotspots[draggedIndexInt!] = {
          ...newHotspots[draggedIndexInt!],
          // clientX and clientX will be radius distance away from the hotspot center.
          // we want clientX and clientY to be center of the hotspot.
          x:
            ((event.clientX - nodeBoudingClientRec.x - HOTSPOT_RADIUS) /
              nodeBoudingClientRec.width) *
            100,
          y:
            ((event.clientY - nodeBoudingClientRec.y - HOTSPOT_RADIUS) /
              nodeBoudingClientRec.height) *
            100,
        };
        setHotspotsState(newHotspots);
        setSelectedHotspot(null);
        updateAttrs({ hotspots: newHotspots });
      }
      event.dataTransfer.clearData('draggedIndex');
    },
    [hotspotsState, nodeElement, setHotspotsState, setSelectedHotspot, updateAttrs],
  );

  // Using useCallback creates problem in setting updateAttrs as multiple dependies of
  // hotspotsState, updateAttrs and setNewHotspotAdded.
  const onContainerClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      const nodeBoudingClientRec = nodeElement?.getBoundingClientRect();
      const newHotspots = [...hotspotsState];
      // clientX and clientX will be radius distance away from the hotspot center.
      // we want clientX and clientY to be center of the hotspot.
      newHotspots.push({
        x:
          ((event.clientX - nodeBoudingClientRec.x - HOTSPOT_RADIUS) / nodeBoudingClientRec.width) *
          100,
        y:
          ((event.clientY - nodeBoudingClientRec.y - HOTSPOT_RADIUS) /
            nodeBoudingClientRec.height) *
          100,
        caption: '',
      });
      setHotspotsState(newHotspots);
      updateAttrs({ hotspots: newHotspots });
      setNewHotspotAdded();
    },
    [hotspotsState, nodeElement, setHotspotsState, setNewHotspotAdded, updateAttrs],
  );

  return (
    <div
      className={c('absolute top-0 h-full w-full start-0', editableHotspotCursor)}
      onClick={onContainerClick}
      onDrop={onDrop}
    />
  );
};

export default HotspotContainer;
